import * as api from './serverApi';

export default process.env.NEXT_PUBLIC_USE_MOCK_API
  ? require('./mockApi')
  : api;
